<script setup>
import { ref, onMounted, computed } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useDishesStore } from "@/stores/storeDishes";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useModals } from "@/utils/useModals";
import ProfileDish from "@/components/profile/ProfileDish.vue";
import ProfileApplication from "@/components/profile/ProfileApplication.vue";

const storeRequests = useRequestsStore();
const storeDishes = useDishesStore();
const storeField = useFieldsStore();
const { openModal } = useModals();

onMounted(async () => {

	
});
</script>
<template>
	<div class="questionnare">
		
		<div class="questionnare__apllication">
			<ProfileApplication />
		</div>
		<p class="questionnare__desc">
			Добавьте фото в интерьере заведения в сопровождении коньяка Courvoisier и опишите 3–4 блюда, с которыми вы хотите участвовать в конкурсе. 
			Вашу заявку рассмотрит модерация. 
			В случае одобрения вы перейдёте к следующему шагу — подтверждению запуска блюд с своём заведении.
		</p>
		<div class="questionnare__dishes-list ">
			<div class="dishes-list">
				<ProfileDish 
					v-for="(dish, index) in storeDishes.listDishes" 
					:index="index" 
					:key="dish.id" 
					:dish="dish" 
					@delete="storeDishes.deleteDish(dish.id)" 
				/>
			</div>
			<button 
				v-if="storeDishes.listDishes.length < 4"
				type="button" 
				class="questionnare__btn-text btn-text" 
				@click="storeDishes.addDish"
			>
				+ Добавить блюдо
			</button>
		</div>
		<p style="color: var(--red);text-align: center;font-size: 16px;margin-bottom: 20px;" class="text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
		<button 
			:disabled="storeField.isApplicationBtn || storeDishes.listDishes.length < 3" 
			class="questionnare__btn form__btn btn --middle mobile-full" 
			type="button"
			@click="storeRequests.survey()"
		>
			<span v-if="!storeRequests.loaderBtn">Отправить заявку</span>
			<img v-else class="form-loader" width="36" height="36" src="@/assets/img/icons/loader_white.svg" alt="изображение" />
		</button>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.questionnare {
	width: 100%;
}
.questionnare__apllication {
	margin-bottom: 5.4rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 4rem;
	}
}
.questionnare__desc {
    max-width: 100%;
	font-weight: 400;
	font-size: 1.8rem;
	line-height: 140%;
	margin-bottom: 3.4rem;
	@media (max-width: vars.$m) {
		max-width: 100%;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
		line-height: 133%;
		margin-bottom: 2.5rem;
	}
}
.questionnare__dishes-list {
	gap: 20px;
	margin-bottom: 40px;
}
.questionnare__btn-text {
	display: block;
	width: fit-content;
	margin: 3.4rem auto 0;
}
.questionnare__btn {
	margin: 0 auto;
}

</style>
